import React, { useEffect, useRef } from 'react';

import { positionSkinBannerPanel } from '../../../../utils/bannerResizer';
import { BANNER_POSITION, bannerPositions } from '../../constants/banners';

import Classes from './BannerOutside.module.scss';

type TBannerOutsideProps = {
  bannerPositionId: string;
};

const BannerOutside = ({ bannerPositionId }: TBannerOutsideProps) => {
  const sideClassName =
    bannerPositionId === bannerPositions[BANNER_POSITION.STATIC.LEFT].id ? Classes.left : Classes.right;

  const containerRef = useRef<HTMLDivElement>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    const wrapper = wrapperRef.current;
    if (!container || !wrapper) return;

    const applyPositioning = () => positionSkinBannerPanel(container, wrapper);

    const mutationObserver = new MutationObserver(applyPositioning);
    mutationObserver.observe(container, { childList: true, subtree: true });

    // GPT may size the iframe after inserting it; the resize observer catches that and viewport changes
    const resizeObserver = new ResizeObserver(applyPositioning);
    resizeObserver.observe(container);

    applyPositioning();

    return () => {
      mutationObserver.disconnect();
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <div ref={wrapperRef} className={`${Classes.root} ${sideClassName}`}>
      <div ref={containerRef} id={bannerPositionId} />
    </div>
  );
};

export default BannerOutside;
